export function downloadFile(blob: any, fileName: string): void {
    const url = window.URL.createObjectURL(new Blob([blob], {type: blob.type} ));
    const link = document.createElement('a');
    link.setAttribute('download', fileName);
    link.setAttribute('href', url);
    link.click();
  }